<template>
    <v-container >
        <v-row no-gutters>
            <v-col>
                <v-chip  small v-if="loading" dark color="pink" ><v-progress-circular indeterminate :size="16"></v-progress-circular> Consultando refis/renos...</v-chip>
                <v-chip  small v-if="!loading && mensaje!='' && info==''" dark color="pink"  @click="editModeOn=true">{{mensaje}}</v-chip>
                <v-chip  small v-if="!loading && info!=''" color="pink" dark @click="editModeOn=true">{{info}}</v-chip>
            </v-col>
        </v-row>

        <v-dialog v-model="editModeOn" width="900" persistent>
            <v-card>
                <v-card-title>
                    <div >Créditos en condiciones de ser Refinanciados o Renovados</div>
                </v-card-title>
                <v-card-text>
                    <v-row >
                        <v-col>
                            <v-row>
                                <v-col>
                                    <div> Seleccione los Créditos a Refinanciar o Renovar</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-data-table dense
                                        single-select
                                        v-model="selectedCreditos"
                                        :headers="headers"
                                        :items="creditos"
                                        :server-items-length="creditos.length"
                                        :loading="loading"
                                        :hide-default-footer="true"
                                        :show-select="creditos.length>0"
                                        item-key="id" 
                                    >

                                        <template v-slot:item="{ item,isSelected, select }">
                                            <tr>
                                                <td><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td>
                                                <td class="text-xs-left caption">{{ item.numero }}</td>
                                                <td class="text-xs-left caption">{{ item.origen }}</td>
                                                <td class="text-xs-left caption">{{ item.producto }}</td>
                                                <td class="text-xs-left caption">{{ item.saldo | formatMoney}}</td>
                                                <td class="text-xs-left caption">{{ item.saldoTotal | formatMoney}}</td>
                                                <td class="text-xs-left caption">{{ item.fechaIngreso | formatDate }}</td>
                                                <td class="text-xs-left caption">
                                                    <v-chip v-if="item.puedeRenovar" label small color="green" dark>Renovar</v-chip>
                                                    <v-chip v-else label small color="indigo" dark>Refinanciar</v-chip>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- <v-col>
                            <v-switch label="Selección por Cuota" 
                                hint="Podrá seleccionar cuotas de forma individual" 
                                :persistent-hint="true"
                                v-model="seleccionPorCuotas"></v-switch>
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-row>
                                <v-col>
                                    <div> Seleccione las Cuotas a Refinanciar o Renovar</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-data-table dense
                                        v-model="selectedCuotasLocal"
                                        :headers="headersCuotas"
                                        :items="cuotas"
                                        :server-items-length="cuotas.length"
                                        :loading="loading"
                                        :hide-default-footer="true"
                                        :show-select="cuotas.length>0 && !selectedCreditos[0].puedeRenovar"
                                        item-key="id"                                        
                                    >
                                        <template v-slot:item="{ item,isSelected, select }">
                                            <tr>
                                                <td v-if="!selectedCreditos[0].puedeRenovar"><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td>
                                                <td class="text-xs-left caption">{{ item.numero }}</td>
                                                <td class="text-xs-left caption">{{ item.cuota }}</td>
                                                <td class="text-xs-left caption">{{ item.vencimiento  | formatDate}}</td>
                                                <td class="text-xs-left caption">{{ item.saldoCuota | formatMoney}}</td>
                                                <td class="text-xs-left caption">{{ item.punitorios | formatMoney}}</td>
                                                <td class="text-xs-left caption">{{ item.cargosAtraso | formatMoney}}</td>
                                                <td class="text-xs-left caption">{{ item.saldoTotal | formatMoney}}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row >
                        <v-col>
                            Selección
                        </v-col>
                        <v-col>
                            Cuotas: {{selectedCuotasLocal.length}}
                        </v-col>
                        <v-col>
                            Importe: {{importeSeleccionadoLocal|formatMoney }}
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row >
                        <v-col>
                            <v-checkbox label="Excluir Punitorios" 
                                hint="No se incuirán los Punitorios en el saldo" 
                                :persistent-hint="true"
                                v-model="excluirPunitorios"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox label="Excluir Cargos Atraso" 
                                hint="No se incuirán los Cargos por Atraso en el saldo" 
                                :persistent-hint="true"
                                v-model="excluirCargosAtraso"></v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="editModeOn=false">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="confirmar">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import { format } from 'date-fns'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data () {
        return{
            loading: false,
            editModeOn: false,
            headers: [ // definición de columnas
                { text: 'Número', value: 'numero' , width: 90},
                { text: 'Origen', value: 'origen' },
                { text: 'Producto', value: 'producto', width: 90},
                { text: 'Saldo Ctas.', value: 'saldo'},
                { text: 'Saldo Total', value: 'saldoTotal'},
                { text: 'Fecha Ing.', value: 'fechaingreso', width: 100},
                { text: 'Puede', value: 'puede', width: 100},
            ],
            headersCuotas: [ // definición de columnas
                { text: 'Crédito Nº', value: 'numero' , width: 100},
                { text: 'Cuota', value: 'cuota' },
                { text: 'Vencimiento', value: 'vencimiento'},
                { text: 'Saldo Cta.', value: 'saldoCuota', width: 100},
                { text: 'Punit.', value: 'punitorios', width: 100},
                { text: 'Cargos Cob.', value: 'cargosAtraso', width: 100},
                { text: 'Saldo Total', value: 'saldoTotal', width: 100},
            ],
            seleccionPorCuotas: false,
            excluirPunitorios: false,
            excluirCargosAtraso: false,
            creditos: [],
            selectedCreditos:[],            
            selectedCuotasLocal: []
        }
    },
    filters: {
        formatDate: function (value) {
        if (value) 
            return format(value, 'DD-MM-YYYY')
        
        },
        formatMoney: function(value) {
            if(value)
            {
                if(Number.isInteger(value))
                return '$ ' + value + '.00';
                else
                return '$ ' + value;
            }
        }
    },
    props:{
        personaId: String,
        empresaId: Number,
        seleccionConfirmada: Function,
        selectedCuotas: Array
    },
    computed:{
        ...mapGetters(['user', 'DebugModeOn']),
        mensaje: function (){
            if(!this.creditos || this.creditos.length==0)
                return '';
            return 'Hay Créditos para Refi/Reno'

        },
        info: function(){
            if(!this.selectedCuotas || this.selectedCuotas.length==0)
                return '';
            
            if(this.selectedCreditos.length>0 && this.selectedCreditos[0].puedeRenovar)
                return 'Importe Renova: $ ' + this.importeSeleccionado;
            else
                return 'Importe Refi: $ ' + this.importeSeleccionado;
        },
        cuotas: function(){
            var list = [];

            for (let index = 0; index < this.selectedCreditos.length; index++) {
                const credito = this.selectedCreditos[index];

                for (let j = 0; j < credito.cuotasAdeudadas.length; j++) {
                    const cta = credito.cuotasAdeudadas[j];
                    
                    list.push(cta)                    
                }                
            }
            return list;
        },
        importeSeleccionado: function(){
            var total = 0;

            for (let index = 0; index < this.selectedCuotas.length; index++) {
                const element = this.selectedCuotas[index];
                
                total = total +  parseFloat(element.saldoCuota)
                if(!this.excluirPunitorios)
                    total = total +  parseFloat(element.punitorios)
                if(!this.excluirCargosAtraso)
                    total = total +  parseFloat(element.cargosAtraso)
                
            }
            return total;
        },
        
        importeSeleccionadoLocal: function(){
            var total = 0;

            for (let index = 0; index < this.selectedCuotasLocal.length; index++) {
                const element = this.selectedCuotasLocal[index];
                
                total = total +  parseFloat(element.saldoCuota)
                if(!this.excluirPunitorios)
                    total = total +  parseFloat(element.punitorios)
                if(!this.excluirCargosAtraso)
                    total = total +  parseFloat(element.cargosAtraso)
                
            }
            return total;
        }
    },
    async created() {
      if(this.personaId)
        this.cargarCreditos();
    },
    watch:{ 
        'personaId': function(){
            if(this.personaId)
                this.cargarCreditos();
        },
        selectedCreditos :{
            handler(){
                // marco todas las cuotas
                this.selectedCuotasLocal= [];
                for (let index = 0; index < this.cuotas.length; index++) {
                    const element = this.cuotas[index];
                    this.selectedCuotasLocal.push(element); 
                }
            },
            deep: false
        },
    },
    methods:{
        ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),        
        async cargarCreditos(){
            console.log('cargarcreditos')

            this.selectedCreditos = [];
            this.selectedCuotasLocal=[];
            
            //cargo los créditos para renovar o refinanciar de la persona
            this.loading = true
            try {                
                this.loading = true

                var res = await http.get('creditos/listcreditospararenovarorefinanciarporpersonayempresa?empresaId=' + this.empresaId + '&personaId=' + this.personaId );                
                this.creditos = res.list;
                
                if(this.selectedCuotas.length > 0){
                    var credito = this.creditos.find(c=>c.id == this.selectedCuotas[0].creditoId);

                    if(credito != null)
                        this.selectedCreditos.push(credito);
                }

            } catch (error) {
                // Error
                this.alertError(error)
            }

            this.loading = false
        },
        confirmar(){
            // le agrego el atributo de renovación en caso que corresponda
            for (let i = 0; i < this.selectedCuotasLocal.length; i++) {
                const item = this.selectedCuotasLocal[i];
                item.esRenovacion = this.selectedCreditos[0].puedeRenovar;
            }

            this.$emit('listchange', this.selectedCuotasLocal); // aviso los cambios
            
            if(this.seleccionConfirmada)
                this.seleccionConfirmada(this.selectedCuotasLocal);

            this.editModeOn=false
        }
    }
}
</script>